"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var Spinner = (0, core_1.styled)('span')({
    display: 'inline-block',
    width: 50,
    height: 50,
    border: '6px solid #96969626',
    borderRadius: '50%',
    borderTopColor: function (_a) {
        var color = _a.color;
        return color;
    },
    animation: 'spin 0.7s ease-in-out infinite'
});
exports.default = (0, core_1.withStyles)({
    '@global': {
        '@keyframes spin': {
            to: {
                transform: 'rotate(360deg)'
            }
        }
    }
})(function (props) { return (react_1.default.createElement(Spinner, __assign({}, props))); });
//# sourceMappingURL=Spinner.js.map